var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayTextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 33.001,
    viewBox: "0 0 27 33.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-text",
    "data-name": "Icon feather-file-text",
    transform: "translate(-4.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_16",
    "data-name": "Union 16",
    d: "M7023.5-7899a4.505,4.505,0,0,1-4.5-4.5v-24a4.505,4.505,0,0,1,4.5-4.5h12.037a1.494,1.494,0,0,1,1.052.47l8.972,8.969a1.5,1.5,0,0,1,.334.511h0l.011.028,0,.009c0,.007,0,.014.007.021l.006.017,0,.012.008.025,0,.005a1.512,1.512,0,0,1,.059.321v0c0,.011,0,.023,0,.034s0,.013,0,.019,0,.013,0,.019,0,.025,0,.038v18a4.5,4.5,0,0,1-4.5,4.5Zm-1.5-28.5v24a1.5,1.5,0,0,0,1.5,1.5h18a1.5,1.5,0,0,0,1.5-1.5V-7920h-7.5a1.5,1.5,0,0,1-1.5-1.5v-7.5h-10.5A1.5,1.5,0,0,0,7022-7927.5Zm15,4.5h3.878L7037-7926.88Zm-10.5,16.5a1.5,1.5,0,0,1-1.5-1.5,1.5,1.5,0,0,1,1.5-1.5h12a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5Zm0-6a1.5,1.5,0,0,1-1.5-1.5,1.5,1.5,0,0,1,1.5-1.5h12a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5Zm0-6a1.5,1.5,0,0,1-1.5-1.5,1.5,1.5,0,0,1,1.5-1.5h3a1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5Z",
    transform: "translate(-7014.5 7933.5)",
    fill: "#7b7b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTextIcon);
export default __webpack_public_path__ + "static/media/gray-text-icon.006f270c57c4c655acaabafb204c9e21.svg";
export { ForwardRef as ReactComponent };